import React from 'react';

const ProductDetailsSkeleton = () => {
  return (
    <div className="animate-pulse">
      {/* Banner Skeleton - Simplified */}
      <div className="h-[220px] bg-[var(--store-card-bg)] w-full mb-5"></div>

      {/* Main Content Skeleton */}
      <section>
        <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto pb-16">
          <div className="grid grid-cols-2 md-lg:grid-cols-1 gap-8">
            {/* Image Section */}
            <div>
              <div className="bg-[var(--store-card-bg)] sm:h-[300px] h-[400px] w-full rounded-lg"></div>
            </div>

            {/* Product Info Section - Simplified */}
            <div className="flex flex-col gap-5">
              <div className="h-8 bg-[var(--store-card-bg)] rounded w-3/4"></div>
              <div className="h-6 bg-[var(--store-card-bg)] rounded w-1/2"></div>
              
              <div className="h-8 bg-[var(--store-card-bg)] rounded w-1/3"></div>
              
              <div className="space-y-2">
                <div className="h-4 bg-[var(--store-card-bg)] rounded w-full"></div>
                <div className="h-4 bg-[var(--store-card-bg)] rounded w-5/6"></div>
              </div>

              <div className="flex gap-3 mt-4">
                <div className="h-10 bg-[var(--store-card-bg)] rounded w-32"></div>
                <div className="h-10 bg-[var(--store-card-bg)] rounded w-32"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductDetailsSkeleton;